import React, { forwardRef } from 'react';
import { useMergeRefs } from 'use-callback-ref';
import { DefaultList, ListStyleProvider, } from '@clds/compound-components';
import { useMenu } from './headless/useMenu.js';
import { useMenuState } from './headless/useMenuState.js';
import { MenuProvider } from './MenuProvider.js';
/**
 * Component that manages list of items and controls navigation and focus state.
 * It doesn't control selection! This is only applicable for components that compose it
 * This component is useful when used together with other components, for example with Popover or Drawer
 */
// eslint-disable-next-line react/display-name
export const Menu = forwardRef(({ children, variant, defaultFocusedId, focusedId, onFocusedIdChange, defaultSelectedId, selectedId, onSelect, maxHeight, ...rest }, ref) => {
    const state = useMenuState({
        defaultFocusedId,
        focusedId,
        onFocusedIdChange,
        defaultSelectedId,
        selectedId,
        onSelect,
    });
    const menu = useMenu(state);
    const mergedRef = useMergeRefs([menu.descendantsParentRef, ref]); // TODO maybe ref should go after state to useMenu
    return (React.createElement(MenuProvider, { ...menu.menuProviderProps },
        React.createElement(ListStyleProvider, { ...variant },
            React.createElement(DefaultList, { ...menu.focusableProps, ref: mergedRef, maxHeight: maxHeight, ...rest }, children))));
});
//# sourceMappingURL=Menu.js.map